import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { toUpper } from 'lodash';
import { message, Popconfirm } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';
import IconDelete from '@/assets/icon-delete.svg?react';
import { EPButton } from '@/components';

const CUSTOM_ALERT_TYPE = 'CUSTOM';
const MANUFACTURER_ALERT_TYPE = 'MANUFACTURER';

const DeleteRuleColumn = observer(({ alertRule, isSingleMode }) => {
  const { stationId } = useParams();
  const { rulesStore, permissionStore } = useStores();
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();
  const disabled = (() => {
    switch (toUpper(alertRule.alertType)) {
      case CUSTOM_ALERT_TYPE:
        return !permissionStore.isAuth(permissions.DELETE_CUSTOM_ALERT);

      case MANUFACTURER_ALERT_TYPE:
        return true;

      default:
        return true;
    }
  })();

  const navigateToRulesPage = () => {
    navigate(`/home/station/${stationId}/rules`);
  };

  const onConfirm = async () => {
    setIsDeleting(true);
    try {
      await rulesStore.delete(alertRule);
      setIsDeleting(false);
      if (isSingleMode) {
        navigateToRulesPage();
      }
    } catch (e) {
      setIsDeleting(false);
      message.error(t('Failed to delete rule'));
    }
  };

  return (
    <div>
      {toUpper(alertRule.alertType) === CUSTOM_ALERT_TYPE && !alertRule.complexFormula ? (
        isDeleting ? (
          <LoadingOutlined spin />
        ) : (
          <Popconfirm
            placement="bottom"
            title={t('Are you sure you want to delete this rule?')}
            onConfirm={onConfirm}
            okText={t('Yes')}
            cancelText={t('Cancel')}
            icon={null}
            disabled={disabled}
          >
            <EPButton className="action-button" type="link" icon={<IconDelete />} disabled={disabled} />
          </Popconfirm>
        )
      ) : null}
    </div>
  );
});

export default DeleteRuleColumn;
